import { ROUTES_CONFIG } from "../../../../config/routes";
import { SEOImage } from "../../../../components/seo/SEOImage";

export const HubGuideContentES = () => (
    <>
        <div className="lead text-xl text-slate-300 mb-12 font-medium border-l-4 border-purple-500 pl-6 bg-slate-800/30 py-4 rounded-r-lg">
            Bienvenido al repositorio de conocimientos sobre Teleprompters más grande de internet. Si quieres grabar mejores videos, hablar con confianza y dominar la cámara, estás en el lugar correcto.
        </div>

        <SEOImage
            slug="guia-completo-teleprompter"
            src="complete-guide-teleprompter-everything-about.webp"
            alt="Guía Completa de Teleprompter - Herramientas y Técnicas Hub"
            caption="Nuestro centro de conocimiento reúne todo lo necesitas para dominar el arte de hablar frente a la cámara."
            width={1200}
            height={675}
        />

        <section id="oque" className="mb-16">
            <h3 className="text-3xl font-bold text-white mb-6 flex items-center gap-3">
                <span className="bg-purple-600 w-8 h-8 rounded-full flex items-center justify-center text-sm">1</span>
                ¿Qué es un Teleprompter?
            </h3>
            <p className="mb-4">
                El <a href={ROUTES_CONFIG.SEO_O_QUE_E.paths.es}>Teleprompter</a> (o "prompter") es la herramienta secreta detrás de presentadores de TV, presidentes y YouTubers exitosos. Te permite leer un guion mientras miras directamente a la lente de la cámara.
            </p>
            <p className="mb-4">
                Para entender el origen de esta tecnología, echa un vistazo a nuestra <a href={ROUTES_CONFIG.SEO_HISTORY.paths.es}>Historia del Teleprompter</a>. También es importante no confundirlo con el <a href={ROUTES_CONFIG.SEO_VS_TELELESTRADOR.paths.es}>Telestrator</a>, usado para dibujar en pantalla.
            </p>
            <p>
                Esto crea una conexión inmediata con tu audiencia porque simula el contacto visual natural. Nadie nota que estás leyendo y nunca olvidas lo que tienes que decir. Mira <a href={ROUTES_CONFIG.SEO_CELEBRITIES.paths.es}>qué celebridades usan teleprompter</a> a diario.
            </p>
        </section>

        <section id="como-usar" className="mb-16">
            <h3 className="text-3xl font-bold text-white mb-6 flex items-center gap-3">
                <span className="bg-purple-600 w-8 h-8 rounded-full flex items-center justify-center text-sm">2</span>
                Cómo Usar (Paso a Paso)
            </h3>
            <p>
                Usar un teleprompter hoy es mucho más fácil que en la era de la TV analógica. No necesitas equipos de $1,000.
            </p>
            <h3 className="text-xl font-bold text-white mt-8 mb-4">El Setup Básico</h3>
            <ul className="list-disc pl-6 space-y-4 marker:text-purple-500 text-slate-300">
                <li>
                    <strong>En PC:</strong> Solo accede a <a href={ROUTES_CONFIG.SEO_PC_WINDOWS.paths.es}>PromptNinja en tu navegador</a>. Ideal para clases online, Zoom y Google Meet.
                </li>
                <li>
                    <strong>En Móvil/Tablet:</strong> Usa nuestra <a href={ROUTES_CONFIG.SEO_PWA_INSTALL.paths.es}>Web App (PWA)</a> que funciona sin conexión. Coloca el móvil cerca de la lente de la cámara.
                </li>
                <li>
                    <strong>Kit Profesional:</strong> Usa un "Beam Splitter" (vidrio reflectante) con una <a href={ROUTES_CONFIG.SEO_TABLET.paths.es}>Tablet</a> debajo. ¿Dudas si invertir? Lee nuestra guía sobre <a href={ROUTES_CONFIG.SEO_BUYING_GUIDE.paths.es}>Cómo Elegir un Teleprompter</a>.
                </li>
            </ul>
        </section>

        <section id="apps" className="mb-16">
            <h3 className="text-3xl font-bold text-white mb-6 flex items-center gap-3">
                <span className="bg-purple-600 w-8 h-8 rounded-full flex items-center justify-center text-sm">3</span>
                Mejores Apps y Herramientas
            </h3>
            <p className="mb-4">
                Hay docenas de opciones, pero el futuro es <strong>Web-Based</strong> con IA. Conoce qué esperar del <a href={ROUTES_CONFIG.SEO_FUTURE_AI.paths.es}>Futuro de los Teleprompters con IA</a>.
            </p>
            <div className="bg-slate-800 p-6 rounded-xl my-6">
                <h4 className="font-bold text-lg text-white mb-2">¿Por qué PromptNinja?</h4>
                <ul className="grid md:grid-cols-2 gap-4 text-slate-300">
                    <li className="flex items-center gap-2">✅ <strong>100% Gratis</strong> (sin marcas de agua gigantes)</li>
                    <li className="flex items-center gap-2">✅ <strong>Privacidad Total</strong> (tus datos no salen de tu PC)</li>
                    <li className="flex items-center gap-2">✅ <strong>Control por Voz</strong> (el texto avanza cuando hablas)</li>
                    <li className="flex items-center gap-2">✅ <strong>Accesibilidad</strong> (incluye fuente OpenDyslexic. Ver más en <a href={ROUTES_CONFIG.SEO_ACCESSIBILITY.paths.es}>Teleprompter y Accesibilidad</a>)</li>
                </ul>
            </div>
            <p>
                Mira nuestra comparación completa de la <a href={ROUTES_CONFIG.SEO_MELHOR_APP.paths.es}>Mejor App de Teleprompter</a> y también <a href={ROUTES_CONFIG.SEO_ALTERNATIVAS.paths.es}>Alternativas a competidores</a>.
            </p>
        </section>

        <section id="diy" className="mb-16">
            <h3 className="text-3xl font-bold text-white mb-6 flex items-center gap-3">
                <span className="bg-purple-600 w-8 h-8 rounded-full flex items-center justify-center text-sm">4</span>
                DIY vs Profesional
            </h3>
            <p className="mb-4">
                Puedes empezar con cero inversión. Tenemos una guía increíble sobre <a href={ROUTES_CONFIG.SEO_DIY.paths.es}>Cómo hacer un Teleprompter Casero</a> usando una caja de CD o vidrio de marco de fotos.
            </p>
            <p>
                Si buscas la máxima calidad para YouTube, mira nuestros consejos de <a href={ROUTES_CONFIG.SEO_HARDWARE_VS_WEB.paths.es}>Hardware vs Software</a>. Evita <a href={ROUTES_CONFIG.SEO_COMMON_MISTAKES.paths.es}>Errores Comunes al usar Teleprompter</a> que delatan que estás leyendo.
            </p>
        </section>

        <section id="casos" className="mb-16">
            <h3 className="text-3xl font-bold text-white mb-6 flex items-center gap-3">
                <span className="bg-purple-600 w-8 h-8 rounded-full flex items-center justify-center text-sm">5</span>
                Casos de Uso Específicos
            </h3>
            <div className="grid md:grid-cols-2 gap-6">
                <div className="bg-slate-800/50 p-6 rounded-xl border border-slate-700 hover:border-purple-500 transition-colors">
                    <h3 className="font-bold text-white mb-2">📹 Youtubers y Creadores</h3>
                    <p className="text-sm text-slate-400 mb-4">
                        Graba videos largos en "One Take". Descubre también cómo usar <a href={ROUTES_CONFIG.SEO_LIVES.paths.es} className="text-purple-300 hover:underline">Teleprompter en Directos (OBS)</a>.
                    </p>
                    <a href={ROUTES_CONFIG.SEO_YOUTUBERS.paths.es} className="text-purple-400 text-sm font-bold hover:underline">Ver Guía para Creadores →</a>
                </div>
                <div className="bg-slate-800/50 p-6 rounded-xl border border-slate-700 hover:border-purple-500 transition-colors">
                    <h3 className="font-bold text-white mb-2">🎙️ Podcasters</h3>
                    <p className="text-sm text-slate-400 mb-4">
                        Ideal para leer anuncios y bios de invitados.
                    </p>
                    <a href={ROUTES_CONFIG.SEO_PODCAST.paths.es} className="text-purple-400 text-sm font-bold hover:underline">Guía para Podcasters →</a>
                </div>
                <div className="bg-slate-800/50 p-6 rounded-xl border border-slate-700 hover:border-purple-500 transition-colors">
                    <h3 className="font-bold text-white mb-2">🎵 Músicos y Cantantes</h3>
                    <p className="text-sm text-slate-400 mb-4">
                        Nunca más olvides la letra en un show o livestream.
                    </p>
                    <a href={ROUTES_CONFIG.SEO_MODO_MUSICO.paths.es} className="text-purple-400 text-sm font-bold hover:underline">Modo Músico →</a>
                </div>
                <div className="bg-slate-800/50 p-6 rounded-xl border border-slate-700 hover:border-purple-500 transition-colors">
                    <h3 className="font-bold text-white mb-2">🏋️ Fitness y Entrenamientos</h3>
                    <p className="text-sm text-slate-400 mb-4">
                        Da clases de ejercicios cronometradas con perfección usando nuestro timer.
                    </p>
                    <a href={ROUTES_CONFIG.SEO_FITNESS.paths.es} className="text-purple-400 text-sm font-bold hover:underline">Para Entrenadores Personales →</a>
                </div>
            </div>
        </section>

        <section id="recursos" className="mb-16">
            <h3 className="text-3xl font-bold text-white mb-6 flex items-center gap-3">
                <span className="bg-purple-600 w-8 h-8 rounded-full flex items-center justify-center text-sm">6</span>
                Guiones y Oratoria
            </h3>
            <p>
                La herramienta es inútil sin un buen contenido. Por eso, creamos una biblioteca de <a href={ROUTES_CONFIG.SEO_SCRIPTS.paths.es}>Guiones para Teleprompter</a> listos para usar.
            </p>
            <p>
                Además, mira nuestros <a href={ROUTES_CONFIG.SEO_ORATORIA.paths.es}>Consejos de Oratoria para Video</a> y aprende <a href={ROUTES_CONFIG.SEO_DECORAR.paths.es}>cómo memorizar guiones rápido</a> si el prompter falla (lo que no pasará con nosotros, mira nuestra solución <a href={ROUTES_CONFIG.SEO_TRAVANDO.paths.es}>Anti-Congelamiento</a>).
            </p>
        </section>
    </>
);
